import { IDownloadableFile } from "../interfaces/iDownload";

export type SameValueAsKeys<KS extends string[]> = { [K in KS[number]]: K };
export function keyArrayToSameValueAsKeys<T extends string[]>(
  keys: T
): SameValueAsKeys<T>;

export function keyArrayToSameValueAsKeys(
  keys: string[]
): { [k: string]: string } {
  return keys.reduce((acc, type) => ({ ...acc, [type]: type }), {});
}

export const objectKeysToObject = <T extends {}>(o: T) => {
  type TTKeys = keyof T & string;
  const arrTKeys: TTKeys[] = Object.keys(o).map((k) => k as TTKeys);
  return keyArrayToSameValueAsKeys(arrTKeys);
};

export const parseArray = (sArr: string) =>
  sArr.replace(' ', '').replace('[', '').replace(']', '').split(',');

const DownloadLinkAttr = 'download';

export const parseFile = (file: File, callBack: (x: string) => void) => {
  const fileReader = new FileReader();
  const handleFileRead = (/* e: ProgressEvent */) => {
    callBack(String(fileReader.result));
  };
  fileReader.onloadend = handleFileRead;
  fileReader.readAsText(file);
};

export const downloadFile = (file: IDownloadableFile) => {
  const url = window.URL.createObjectURL(file.data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(DownloadLinkAttr, file.filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const convertBlobToJson = async (blob: Blob) => {
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();
      reject(new Error('Problem parsing file'));
    };

    fileReader.onload = () => {
      resolve(JSON.parse(fileReader.result as string));
    };

    if (!blob || blob.size === 0) {
      reject(new Error('Empty file'));
    } else fileReader.readAsText(blob);
  });
};

export const toogleArrayItem = <T extends {}>(arr: T[], item: T): T[] => {
  const idx = arr.indexOf(item);
  const newArr =
    idx > -1 ? [...arr.slice(0, idx), ...arr.slice(idx + 1)] : [...arr, item];
  return newArr;
};

export const submitForm = (fn: () => void) => (
  e: React.KeyboardEvent<HTMLDivElement>
) => e.key === 'Enter' && fn();
